import api from '@pray/shared/utils/api';

export async function schedulePrayRadioDaily({
  artistId,
  dailySeriesId,
  dailyItemId,
  scheduledAt,
}: {
  artistId: string;
  dailySeriesId: string;
  dailyItemId: string;
  scheduledAt: string;
}) {
  if (!artistId) throw Error('Artist ID is required');
  if (!dailySeriesId) throw Error('Daily Series ID is required');
  if (!dailyItemId) throw Error('Daily Item ID is required');
  if (!scheduledAt) throw Error('scheduledAt is required');

  const url = `/web/studio/artists/${artistId}/daily-series/${dailySeriesId}/daily-items/${dailyItemId}/pray-radio-schedule`;
  const response = await api.executePostRequest(url, { scheduled_at: scheduledAt });

  return response.data;
}
